import { StockDetails } from '../../../store/api';

export enum SimpleManageSubscriptionTableCell {
    UsageLimitValue = 'UsageLimitValue',
    UsageLimitUnlimited = 'UsageLimitUnlimited',
    UsageLimitNone = 'UsageLimitNone',
    Expired = 'Expired',
    Ceased = 'Ceased'
}

export enum ExtendedManageSubscriptionTableOverviewCell {
    UsageLimitValue = 'UsageLimitValue',
    UsageLimitNone = 'UsageLimitNone',
    Expired = 'Expired',
    Ceased = 'Ceased'
}

export enum ExtendedManageSubscriptionTableIndividualCell {
    UsageLimitValue = 'UsageLimitValue',
    UsageLimitUnlimited = 'UsageLimitUnlimited',
    UsageLimitNone = 'UsageLimitNone',
    Expired = 'Expired',
    Ceased = 'Ceased'
}

export enum ManageSubscriptionTableCell {
    UsageLimitValue = 'UsageLimitValue',
    UsageLimitNone = 'UsageLimitNone',
    UsageLimitNotRenewed = 'UsageLimitNotRenewed'
}

export type ManageSubscriptionUsageLimitValue = {
    type: ManageSubscriptionTableCell.UsageLimitValue;
    label: string;
    stockDetails: StockDetails;
};
export type ManageSubscriptionUsageLimitNone = {
    type: ManageSubscriptionTableCell.UsageLimitNone;
    label: string;
};
